export const NOTIFICATIONS_UPDATED_EVENT = 'darb-notifications-updated';

export function dispatchNotificationsUpdated(): void {
  window.dispatchEvent(new CustomEvent(NOTIFICATIONS_UPDATED_EVENT));
}
